import Countdown from '@/components/Countdown'
import SvgLib from '@/components/SvgLib'

export default {
  name: 'Overview',
  template: '#overview-template',
  components: { Countdown, SvgLib },
  data () {
    return {
      returnToPage: undefined,
      scrollInt: 0.1,
      scrollProgress: 0,
      scrollMax: 0,
      readyStateInt: 0,
      showCountdown: false
    }
  },
  watch: {
    scrollProgress (n, o) {
      if (n > o && n > this.scrollMax) {
        this.scrollMax++
        this.trackEvent('Full Clash Overview', 'Full Clash Overview: Page Scroll: ' + this.scrollMax * 10 + '%')
      }
    }
  },
  methods: {
    close () {
      this.$router.push(this.returnToPage)
    },
    scrollToElement () {
      this.$nextTick(() => {
        window.removeEventListener('load', this.scrollToElement)
        const qs = window.location.href.split('?')
        let kv = qs[1].split('&')
        for (let k in kv) {
          let el = document.getElementById(kv[k])
          if (el) {
            let offsetY = el.getBoundingClientRect().top - 20
            if (offsetY < 1) {
              this.readyStateInt = setInterval(this.readyStateListener, 250)
            } else {
              setTimeout(window.scrollTo, 250, 0, offsetY)
            }
          }
        }
      })
    },
    onScroll (e) {
      let bounds = this.$root.$el.getBoundingClientRect()
      let pct = (Math.abs(bounds.top) + window.innerHeight) / bounds.height
      this.scrollProgress = Math.round(pct / this.scrollInt)
    },
    readyStateListener () {
      if (document.readyState === 'complete') {
        try {
          document.documentElement.scrollTo(0, 0)
        } catch (e) {
          document.body.scrollTop = 0
        }
        clearInterval(this.readyStateInt)
        this.scrollToElement()
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.onScroll)
  },
  mounted () {
    document.body.classList.add('scroll')
    const qs = window.location.href.split('?')
    if (qs.length > 1) {
      this.readyStateInt = setInterval(this.readyStateListener, 250)
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.returnToPage = from.path
      vm.trackEvent(from.meta.track, from.meta.track + ': Link: Full Clash Overview')
    })
  },
  beforeRouteLeave (to, from, next) {
    document.body.classList.remove('scroll')
    window.removeEventListener('scroll', this.onScroll)
    try {
      document.documentElement.scrollTo(0, 0)
    } catch (e) {
      document.body.scrollTop = 0
    }
    next()
  }
}



// WEBPACK FOOTER //
// ./src/components/Overview.js